namespace Account
{
	export class Login
	{
		private LoginForm: JQuery | null;

		private LoginMessage: string;

		public constructor()
		{
			this.LoginForm = null;
			this.LoginMessage = '';
		}

		public createLoginBox(): void
		{
			const form = new ui.Form.Form({
				autocomplete: "off",
				notSwitchable: true,
				action: 'account/login',
				method: 'POST',
				classes: ['form-horizontal login_box'],
				submit: (_method: ui.Form.FormMethod, _url: string, params: ui.Form.IFormParameter) =>
				{
					// Todo Move login handling complete to this location
					app.getAuthenticationManager().login(_url, params);
				}
			});
			form.Initialize();

			this.LoginForm = form.Root();

			const inputUser = new ui.Form.TextInput('',
				{
					control: true,
					required: true,
					name: 'username',
					// attr: {type: 'email'},
					placeholder: 'E-Mail Adresse',
					id: 'username'
				}
			);
			inputUser.Initialize();

			const fgUser = ui.$$.div().addClass('form-group')
				.append('<label class="control-label col-sm-4">Benutzername/E-Mail</label>')
				.append(SPA.gui.Bootstrap.Column('col-sm-8', [inputUser.Input()]));

			const inputPass = new ui.Form.TextInput('',
				{
					noautocomplete: true,
					control: true,
					name: 'password',
					attr: {type: 'password'},
					required: true,
					placeholder: 'Ihr Passwort',
					id: 'password'
				}
			);
			inputPass.Initialize();

			const inputRemember = new ui.Form.Checkbox({
				title: 'Angemeldet bleiben',
				value: "1",
				descriptor:
					{
						name: 'remember_me',
					}
				}, true);
			inputRemember.Initialize();
			form.Input([inputUser, inputPass, inputRemember]);

			const fgPass = ui.$$.div().addClass('form-group')
				.append('<label class="control-label col-sm-4">Passwort</label>')
				.append(SPA.gui.Bootstrap.Column('col-sm-8', [inputPass.Input()]));

			const fgRemember = ui.$$.div().addClass('form-group')
				.append(SPA.gui.Bootstrap.Column(['col-sm-8', 'col-sm-offset-4'],
					[inputRemember.Root()])
				);

			const fgBtnLogin = ui.$$.div().addClass('form-group')
				.append(SPA.gui.Bootstrap.Column(['col-sm-4', 'col-sm-offset-4'],
					['<button type="submit" class="btn btn-primary btn-block">Login</button>'])
				);

			$('<div class="login-wrapper">')
				.append(this.LoginForm
					.append('<h1>GSD-Rapid Login</h1>')
					.append(fgUser)
					.append(fgPass)
					.append(fgRemember)
					.append(fgBtnLogin)
				)
				.appendTo($('body'));

			if (this.LoginMessage) {
				fgUser.prepend('<p class="col-xs-12">' + this.LoginMessage + '</p>');
			}
		}

		public setLoginMessage(message: string): void
		{
			this.LoginMessage = message;
		}

		private onLoginSuccess(): void
		{
			if (this.LoginForm)
			{
				this.LoginForm.fadeOut().remove();
			}
		}

		private onLogoutSuccess(): void
		{
			this.createLoginBox();
		}
	}
}
